import { ArrowDown } from 'lucide-solid'
import type { JSX, ParentProps } from 'solid-js'
import { Box, Flex } from 'styled-system/jsx'
import { Collapsible } from '../ui/collapsible'
import { IconButton } from '../ui/icon-button'

export const AppCollapsible = (
	props: ParentProps<Collapsible.RootProps & { headerContent: JSX.Element }>,
) => {
	return (
		<Collapsible.Root
			{...props}
		>
			<Flex
				justifyContent="space-between"
				alignItems="center"
        width='100%'
			>
        {props.headerContent}
				<Collapsible.Trigger
					asChild={(triggerProps) => (
						<IconButton
							{...triggerProps()}
							variant="outline"
						>
							<ArrowDown />
						</IconButton>
					)}
				/>
			</Flex>
			<Collapsible.Content>
				<Box
					bg="colorPalette.default"
					color="colorPalette.fg"
					p="2"
					borderRadius="l3"
					mt="3"
				>
					{props.children}
				</Box>
			</Collapsible.Content>
		</Collapsible.Root>
	)
}
